export const SMVM_RECORDING_REQUEST = "SMVM_RECORDING_REQUEST";
export const SMVM_RECORDING_SUCCESS = "SMVM_RECORDING_SUCCESS";
export const SMVM_RECORDING_FAIL = "SMVM_RECORDING_FAIL";
export const SMVM_RECORDING_RESET = "SMVM_RECORDING_RESET";
